import { Input as ChakraInput, InputProps } from '@chakra-ui/react';
import { FC } from 'react';

export const Input: FC<InputProps> = (props) => (
  <ChakraInput {...props} variant="flushed" className="form-input" />
);
